import {createActionWithPayload} from "../utils.actions";
import {AutoComplete} from "../../../types/common-search";

export const [autoComplete, isAutoCompleteAction] = createActionWithPayload<AutoComplete>('SEARCH_AUTOCOMPLETE');
export const [autoCompleteSuccess, isAutoCompleteSuccesAction] = createActionWithPayload<{ attribute: string, results: string[] }>('SEARCH_AUTOCOMPLETE_SUCCESS');
export const [autoCompleteError, isAutoCompleteErrorAction] = createActionWithPayload<string>('SEARCH_AUTOCOMPLETE_ERROR');
